import React from "react"
import Layout from "../components/layout"
import Main from "../components/MainContent"

const About = () => {
  return (
    <Layout>
      <Main>About info</Main>
    </Layout>
  )
}

export default About
